<template>
  <div class="live live01">
    <div class="inner">
      <div class="timeschedule">
        <p class="title">タイムスケジュール</p>
        <div
           class="tab"
         >
          <span class="tab-content" :class="{'selected': contentType === 'all' || !contentType }" @click.prevent="changeTab('all')">すべて</span>
          <span class="tab-content" :class="{'selected': contentType === 'company' }" @click.prevent="changeTab('company')">キーワード付き企業LIVE</span>
          <span class="tab-content" :class="{'selected': contentType === 'provider' }" @click.prevent="changeTab('provider')">学び・遊び体験LIVE</span>
        </div>
      </div>
      <div
        class="comingsoon"
        v-if="month === '202008'"
      >
        <figure>
          <img src="/img/logo.svg">
          <figcaption>
            COMING SOON<br>
            お楽しみに♪
          </figcaption>
        </figure>
      </div>
      <div v-else>
        <div slot="spinner" v-if="!loaded">
          <Spinner />
        </div>
        <div class="live-programs">
          <template v-show="selectTime === 'すべて'">
            <template v-for="(frame, key) in displayDeliveryFrames">
              <div class="time" :key="`time-${key}`" v-show="selectTime === 'すべて' && loaded">
                <div class="line">{{ displayDeliveryFrameTable[frame] }}</div>
                <div class="circle"></div>
              </div>
              <div class="verticalline" :key="key+frame" v-show="selectTime === 'すべて' && loaded">
                <LiveProgram09
                  class="card"
                  v-for="(program, idx) in allLives(frame)"
                  :key="program.id + idx"
                  :program="program"
                  :liveType="getLiveType(program)"
                  :month="month"
                />
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import LiveProgram09 from '@/components/molecules/202009sendai/LiveProgram.vue'
import Spinner from '@/components/atoms/Spinner.vue'

export default {
  props: {
    month: {
      type: String,
      required: true
    }
  },
  components: {
    LiveProgram09,
    Spinner
  },
  data: () => ({
    contentType: '',
    loaded: false,
    table0915Provider: {
      1: '10:30',
      2: '11:00',
      3: '11:30',
      4: '12:00',
      5: '12:30',
      6: '13:00',
      7: '13:30',
      8: '14:00',
      9: '14:30',
      10: '15:00'
    },
    table0915Company: {
      0: '10:00',
      1: '10:30',
      2: '11:00',
      3: '11:30',
      4: '12:00',
      5: '12:30',
      6: '13:00',
      7: '13:30',
      8: '14:00',
      9: '14:30',
      10: '15:00',
      11: '15:50'
    },
    providerDeliveryFrames: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    companyDeliveryFrames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
  }),
  computed: {
    ...mapState([
      'dateTab',
      'selectTime'
    ]),
    ...mapGetters([
      'companyLive0915',
      'providerLive0915'
    ]),
    displayDeliveryFrames () {
      if (this.contentType === 'provider') {
        return this.providerDeliveryFrames
      }
      return this.companyDeliveryFrames
    },
    displayDeliveryFrameTable () {
      if (this.contentType === 'provider') {
        return this.table0915Provider
      }
      return this.table0915Company
    }
  },
  methods: {
    ...mapActions([
      'getHyblidCompanyLivePrograms',
      'getHyblidProviderLivePrograms'
    ]),
    getLiveType (program) {
      if (program.company_name) {
        return 'company'
      }
      return 'provider'
    },
    allLives (frame) {
      let allLives
      if (this.contentType === 'provider') {
        allLives = this.providerLive0915
      } else if (this.contentType === 'company') {
        allLives = this.companyLive0915
      } else {
        allLives = this.companyLive0915.concat(this.providerLive0915)
      }
      allLives = allLives.filter((item, index) => {
        if (item.deliveryFrame.includes(frame)) {
          return true
        }
      })
      return allLives
    },
    change: function (num) {
      this.active = num
    },
    changeTab (contentType) {
      this.contentType = contentType
    },
    changeParticipateType (real) {
      if (real === 'real') {
        this.isReal = true
      } else {
        this.isReal = false
      }
    }
  },
  async mounted () {
    await Promise.all([this.getHyblidCompanyLivePrograms(), this.getHyblidProviderLivePrograms()])
    this.loaded = true
  }
}
</script>

<style lang="sass" scoped>
.live01
  padding: 20px 0 25px
.timeschedule
  margin: 0 -20px
.title
  font-size: 20px
  font-weight: bold
  color: #00AC3D
  margin-bottom: 50px
.tab
  text-align: center
  font-size: 15px
  max-width: 600px
  margin: 0 auto 35px auto
  background-color: #fff
  display: flex
  .tab-content::selection
    background-color: #FCF4F7
    border-bottom: 0
  .tab-content
    border: 2px solid #EC83A4
    line-height: 50px
    text-decoration: none
    color: #EC83A4
    font-weight: bold
    padding: 10px
    width: 35%
    &.selected
      background-color: #FCF4F7
      border-bottom: 0
    .tab-content:not(:last-child)
     border-right: 0
.time
  margin-top: 20px
  font-size: 20px
  font-weight: bold
  color: #EC83A4
  width: 100%
  max-width: 600px
.line
  display: flex
  align-items: center
  justify-content: center
.line:after
  border-top: 4px dotted
  content: ""
  width: 483px
.line:after
  margin-left: 10px
.circle
  display: inline-block
  width: 20px
  height: 20px
  text-align: center
  line-height: 80px
  border-radius: 50%
  border: solid 6px #EC83A4
  margin-top: 10px
  margin-left: -13px
.verticalline
  width: 100%
  max-width: 600px
  border-left: solid 6px #EC83A4
  margin-left: -5px
  margin-top: -5px
  margin-bottom: 25px
  display: flex
  flex-wrap: wrap
.card
  display: flexv
  margin-right: 0px
  margin-left: 10px
  width: 50%
  box-sizing: border-box
</style>
